<template>
    <div class="block main">
        <div v-if="!!error" class="notification is-danger is-light">
            <p>{{ error }}</p>
        </div>
        <table class="table">
            <tr>
                <td>
                    Search mode
                </td>
                <td>
                    <div style="display: flex; flex-direction: column; gap: 0.25rem;">
                        <label class="radio">
                            <input type="radio" name="action" v-model="searchAction" :value='"COUNT"'/>
                            Count Beneficiaries
                        </label>
                        <label class="radio" style="margin-left: 0;">
                            <input type="radio" name="action" v-model="searchAction" :value='"COUNT_BAGS"'/>
                            Count Bags
                        </label>
                        <label class="radio" style="margin-left: 0;">
                            <input type="radio" name="action" v-model="searchAction" :value='"LIST"'/>
                            List
                        </label>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    Location
                </td>
                <td>
                    <div class="radios">
                        <label class="radio">
                            <input type="radio" name="location" v-model="filterByLocation" value="BOTH"/>
                            Both
                        </label>
                        <label class="radio">
                            <input type="radio" name="location" v-model="filterByLocation" value="REDHILL"/>
                            Redhill
                        </label>
                        <label class="radio">
                            <input type="radio" name="location" v-model="filterByLocation" value="TBR"/>
                            TBR
                        </label>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    Status
                </td>
                <td>
                    <div class="radios">
                    <label class="radio">
                        <input type="radio" name="status" v-model="beneficiaryActive" :value="true"/>
                        Active
                    </label>
                    <label class="radio">
                        <input type="radio" name="status" v-model="beneficiaryActive" :value="false"/>
                        Inactive
                    </label>
                </div>
                </td>
            </tr>
            <tr>
                <td>
                    Block
                </td>
                <td>
                    <div class="control">
                        <input class="input" type="text" v-model="searchByBlock" placeholder="89">
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    Street
                </td>
                <td>
                    <div class="control">
                        <input class="input" type="text" v-model="searchByStreet" placeholder="Henderson Road">
                        <p class="help">Starts with. Case Sensitive.</p>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    Halal
                </td>
                <td>
                    <input type="checkbox" v-model="filterByHalal"/>
                </td>
            </tr>
            <tr>
                <td>
                    Not returned bags
                </td>
                <td>
                    <input type="checkbox" v-model="filterNotReturnedBags"/>
                </td>
            </tr>
        </table>
        
        <div class="align-center">
            <div class="block">
                <button class="button is-info is-rounded" 
                    :class="[isLoading ? 'is-loading' : '']"
                    @click="search">Search</button>
            </div>
            <div class="notification" v-if="!isLoading && displaySearchCountResult">
                <p v-if="advancedSearchCountResult">{{ advancedSearchCountResult }} {{ lastSearchAction === 'COUNT_BAGS' ? 'bags' : 'beneficiaries' }} found.</p>
                <p v-else>No {{ lastSearchAction === 'COUNT_BAGS' ? 'bags' : 'beneficiaries' }} found.</p>
            </div>
        </div>
        
        <div v-if="advancedSearchListResult" class="table-container">
            <table class="table">
                <thead>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Unit</th>
                    <th>Block</th>
                    <th>Street</th>
                    <th>Phone</th>
                    <th>Race</th>
                    <th>Dietary Req</th>
                    <th>Remarks</th>
                </thead>
                <tbody>
                    <tr v-for="beneficiary in advancedSearchListResult" :key="beneficiary.id">
                        <td>
                            <router-link :to="`/beneficiary/${beneficiary.id}`">{{ beneficiary.id }}</router-link>
                        </td>
                        <td>
                            {{ beneficiary.full_name }}
                        </td>
                        <td>
                            {{ beneficiary.unit }}
                        </td>
                        <td>
                            {{ beneficiary.block }}
                        </td>
                        <td>
                            {{ beneficiary.street }}
                        </td>
                        <td>
                            {{ beneficiary.contact_number }}
                        </td>
                        <td>
                            {{ beneficiary.race }}
                        </td>
                        <td>
                            {{ beneficiary.dietary_requirement }}
                        </td>
                        <td>
                            {{ beneficiary.remarks }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
       
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoading: false,
            error: null,
            displaySearchCountResult: false,
            lastSearchAction: "COUNT",
            searchAction: "COUNT",
            beneficiaryActive: true,
            searchByStreet: "",
            searchByBlock: "",
            filterByHalal: false,
            filterNotReturnedBags: false,
            filterByLocation: "BOTH"
        }
    },

    computed: {
        advancedSearchCountResult() {
            return this.$store.getters['beneficiary/getBeneficiaryAdvancedSearchCount']
        },
        advancedSearchListResult() {
            return this.$store.getters['beneficiary/getBeneficiaryAdvancedSearchResults'];
        }
    },

    methods: {
        async search() {
            this.isLoading = true;
            this.error = null;
            try { 
                await this.$store.dispatch('beneficiary/advancedSearchBeneficiaries', {
                        searchAction: this.searchAction,
                        beneficiaryActive: this.beneficiaryActive,
                        searchByStreet: this.searchByStreet,
                        searchByBlock: this.searchByBlock,
                        filterByHalal: this.filterByHalal,
                        filterNotReturnedBags: this.filterNotReturnedBags,
                        filterByLocation: this.filterByLocation
                    });
                this.lastSearchAction = this.searchAction;
            } catch (error) {
                this.error = error.message || 'Something went wrong!';
            }
            this.isLoading = false;
            this.displaySearchCountResult = true;
        }
    }
}
</script>